import React, { useEffect, useState } from "react";
import { Step, StepLabel, Stepper } from "@material-ui/core";
import { getCompanyProfileInitialSetup } from "../../services/setup/company-profile/companyProfileService";
import ActivatePlatform from "./ActivatePlatform";
import ChangeAdminPassword from "./ChangeAdminPassword";
import CreateCompanyProfile from "./CreateCompanyProfile";
import UploadCompanyProfileLogo from "./UploadCompanyProfileLogo";
import { Typography } from "@material-ui/core";
import { DateTime } from "luxon";
const InitialSetupWizard = ({ onConfirmComplete }) => {
  const steps = [
    "Activate Invifo Platform",
    "Update Administrator Contact & Password",
    "Create Company Profile",
    "Upload Company Logo",
  ];
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [companyProfile, setCompanyProfile] = useState({
    ID: 0,
    appCode: "CPSET",
    approvalLvl: 0,
    licenseKey: "",
    globalCustomerID: 0,
    globalCustomerLevel: 0,
    globalCustomerDeploymentType: 0,
    globalCustomerBillingType: 0,
    companyName: "",
    phone: "",
    email: "",
    website: "",
    taxpayerID: "",
    currencyID: 0,
    address: "",
    city: "",
    province: "",
    countryCode: "ID",
    postalCode: "",
    companyProfileThemes: [],
    companyProfileLogo: [],
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });
  const [companyProfileImgSrc, setCompanyProfileImgSrc] = useState(null);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  useEffect(() => {
    getCompanyProfileInitialSetupData();
  }, []);

  function getCompanyProfileInitialSetupData() {
    getCompanyProfileInitialSetup().then((response) => {
      const { data, auth } = response.data;
      const { companyProfile, currencies, countries } = data;
      setCompanyProfile(companyProfile);
      if (companyProfile.companyProfileLogo.length > 0) {
        setCompanyProfileImgSrc(companyProfile.companyProfileLogo[0].imagePath);
      }
      setMasterData(currencies, countries);
    });
  }

  const isStepOptional = (step) => {
    //return step === 1;
    return false;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    getCompanyProfileInitialSetupData();
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    getCompanyProfileInitialSetupData();
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    getCompanyProfileInitialSetupData();
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    getCompanyProfileInitialSetupData();
    setActiveStep(0);
  };

  return (
    <React.Fragment>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <div className="horizontal-step-content">
            <div className="row justify-content-center">
              <div className="col-sm-4 col-md-4 col-lg-4">
                <div className="column">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography align="center">
                      All steps completed - you&apos;re finished.
                    </Typography>
                    <Typography align="center">
                      <button
                        type="button"
                        className="btn btn-brand btn-md btn-pill btn-bold my-2"
                        onClick={onConfirmComplete}
                      >
                        <i className="fas fa-handshake"></i>
                        Welcome To Invifo Platform
                      </button>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : activeStep === 0 ? (
        <React.Fragment>
          <ActivatePlatform
            activeStep={activeStep}
            handleBack={handleBack}
            handleSkip={handleSkip}
            handleNext={handleNext}
            companyProfile={companyProfile}
            handleReloadCompanyProfile={handleReloadCompanyProfile}
          />
        </React.Fragment>
      ) : activeStep === 1 ? (
        <React.Fragment>
          <ChangeAdminPassword
            activeStep={activeStep}
            handleBack={handleBack}
            handleSkip={handleSkip}
            handleNext={handleNext}
            companyProfile={companyProfile}
            handleReloadCompanyProfile={handleReloadCompanyProfile}
          />
        </React.Fragment>
      ) : activeStep === 2 ? (
        <React.Fragment>
          <CreateCompanyProfile
            activeStep={activeStep}
            handleBack={handleBack}
            handleSkip={handleSkip}
            handleNext={handleNext}
            companyProfile={companyProfile}
            currencyOptions={currencyOptions}
            countryOptions={countryOptions}
            handleReloadCompanyProfile={handleReloadCompanyProfile}
          />
        </React.Fragment>
      ) : activeStep === 3 ? (
        <React.Fragment>
          <UploadCompanyProfileLogo
            activeStep={activeStep}
            handleBack={handleBack}
            handleSkip={handleSkip}
            handleNext={handleNext}
            companyProfileImgSrc={companyProfileImgSrc}
            companyProfile={companyProfile}
            handleReloadCompanyProfile={handleReloadCompanyProfile}
          />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );

  function setMasterData(currencies = [], countries = []) {
    let currencyOptionsTmp = [];
    let countryOptionsTmp = [];
    if (typeof currencies !== "undefined") {
      currencies.forEach((currency) => {
        currencyOptionsTmp.push({
          value: currency.ID,
          label: currency.currencyCode,
        });
      });
    }

    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }
    setCurrencyOptions(currencyOptionsTmp);
    setCountryOptions(countryOptionsTmp);
  }

  async function handleReloadCompanyProfile() {
    getCompanyProfileInitialSetupData();
  }
};

export default InitialSetupWizard;
